// extracted by mini-css-extract-plugin
module.exports = {"error-message":"error-message-KBKje","errorMessage":"error-message-KBKje"};